// <핫이슈 박스 컴포넌트>

// 2021.11.01 기획서 기준  광고까지 총 5개 박스

// 4. Box Type4
// https://programs.sbs.co.kr/drama/redsky/visualboards/69688
// 영상포토게시판
// 영상포토게시판 중 관리자에서 지정된 게시판
// 게시물 포토의 첫번째 포토를 썸네일로 사용
// 가로 고정, 높이는 이미지 비율에 따라 가변  최대,최소 높이는 지정   ------------ 이부분이 핵심
// 마우스 호버 시 이미지 확대, 텍스트 영역 노출
// 시간은 예약일시, 없으면 등록일시
import React, { useState } from 'react';
import Image from 'next/image';
import ShareBox from './ShareBox';
import Link from 'next/link';
import { toContentDate } from '../../../../../src/common/utils/dateUtil';
import { getClickLinkParams } from '../../../../common/utils/appLinkUtil';

export default function Box(props) {
  const [width, setWidth] = useState(384);
  const [height, setHeight] = useState(0);

  const title = props.title; // 타이틀
  const contentDate = props.content_date; // 게시날짜(데이터 케스팅 유무 확인필요)
  const linkUrl = props.link_url; // 링크 url
  const imgUrlList = props.img_url; // 이미지 주소 urlList

  const handleImageLoad = (e) => {
    const nHeight = e.naturalHeight;
    const nWidth = e.naturalWidth;
    const scale = e.naturalWidth / 384;
    const scaleHeight = nHeight / scale;
    setHeight(scaleHeight);
    if (props.forceUpdate) {
      props.forceUpdate();
    }
  };

  const contentDateCast = contentDate ? toContentDate(contentDate) : '';

    // 이미지 유형 체크
    let imgUrl;
    try {
      const test = imgUrlList[0].substr(0, 4);
      if (test !== 'http') {
        imgUrl = 'https:'+ imgUrlList[0];
        // //console.log('find data childmild imgUrl 11111111  ===>> ' + imgUrl);
        // return (
        //   <>
        //     <Box6 />
        //   </>
        // );
      }else{
        imgUrl = imgUrlList[0];
      }
    } catch (error) {
      console.error(error);
      return (
        <>
          <Box6 />
        </>
      );
    }  

  return (
    <>
      <div className='hotmodule_box_w_type4'>
        <Link href={getClickLinkParams(linkUrl, 'div=hotissue')}>
          <a target={"_blank"} rel={"noopener noreferrer"} className='hmb_link'>
            <div className='hmb_image_w'>
              <div className='hmb_image_inner'>
                {imgUrlList[0].endsWith('.gif')
                  ? <img
                    src={imgUrl}
                    alt={title}
                  />
                  : <Image
                    onLoadingComplete={(e) => handleImageLoad(e)}
                    layout='responsive'
                    objectFit='fill'
                    width={width}
                    height={height}
                    src={imgUrl}
                    alt={title}
                  />}
              </div>
              <div className='hmb_info_w'>
                <div className='hmb_info_inner'>

                  {contentDate != null && contentDateCast !== null && contentDateCast !== '' && (
                    <div className='hmbif_update_time_w'>
                      <span className='icon_update_time'>
                        <svg xmlns='http://www.w3.org/2000/svg' width='15' height='15' viewBox='0 0 15.769 16'>
                          <g data-name='Icon feather-clock' transform='translate(0.5 0.5)'>
                            <path d='M17.769,10.5A7.443,7.443,0,0,1,10.385,18,7.443,7.443,0,0,1,3,10.5,7.443,7.443,0,0,1,10.385,3,7.443,7.443,0,0,1,17.769,10.5Z' transform='translate(-3 -3)' />
                            <path d='M18,9v6.231l4.154,2.077' transform='translate(-11.365 -6.769)' />
                          </g>
                        </svg>
                      </span>
                      <span className='text_update_time'>{contentDateCast}</span>
                    </div>
                  )}
                  <strong className='hmbif_title'>{title}</strong>
                </div>
              </div>
            </div>
          </a>
        </Link>
        <ShareBox data={props} />
      </div>
    </>
  );
}// Finish default function Box()
